// extracted by mini-css-extract-plugin
export var container = "_ma-0";
export var dotAnimation = "_ma-2";
export var dotsLoading = "_ma-1";